import React from 'react';
import {CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../../../../../styles/components/desktop/room/timer.scss';

const Timer = React.memo(function ({timers, isActive}) {
    const {time, baseTime} = timers;
    const currentStepTime = baseTime - time;
    let percentage = currentStepTime * 100 / baseTime
    if (!isActive) return
    return (
        <div className="player__timer">
            <CircularProgressbar
                value={percentage}
                text={`${time}`}
            />
        </div>
    )
})

export default Timer
